import { useAuth } from '@/auth';
import { checkAllPermissions, PERMISSIONS } from '@/auth/permissions';

/**
 * Hook to check if user has any permission to view indicators
 * Returns true if user can see at least one type of indicator
 */
export const useHasAnyIndicatorPermission = () => {
  const { user } = useAuth();
  const userPermissions = user?.permissions || [];

  // Check all indicator-related permissions
  const canManageTramites = checkAllPermissions(userPermissions, [PERMISSIONS.MANAGE_TRAMITES.name]);
  const canViewTramiteStatus = checkAllPermissions(userPermissions, [PERMISSIONS.VIEW_TRAMITE_STATUS.name]);
  const canViewPresupuestosFiles = checkAllPermissions(userPermissions, [PERMISSIONS.VIEW_PRESUPUESTOS_FILES.name]);
  const canViewPresupuestos = checkAllPermissions(userPermissions, [PERMISSIONS.VIEW_PRESUPUESTOS.name]);
  const canViewCostos = checkAllPermissions(userPermissions, [PERMISSIONS.VIEW_COSTOS.name]);

  // Return true if user has at least one permission
  const canSeeAnyIndicator =
    canManageTramites ||
    canViewTramiteStatus ||
    canViewPresupuestosFiles ||
    canViewPresupuestos ||
    canViewCostos;

  return canSeeAnyIndicator;
};
